import React from 'react'
import './RecommendedVideos.css'
import VideoCard from './VideoCard'

function RecommendedVideos() {
    return (
        <div className="recommendedVideos">
            <h2>Recommended</h2>
            <div className="recommendedVideos__videos">
           
             <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
             <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            <VideoCard   
            title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
            views="22M"
            timestamp="1 hour ago"
            channelImage="http://static-1.ivoox.com/canales/2/9/9/3/4511564063992_XXL.jpg"
            channel="Coding Mafia"
            image="https://i.ytimg.com/vi/H9Ht27r7ROk/maxresdefault.jpg"
            />
            
            </div>
            
        </div>
    )
}

export default RecommendedVideos

